// Department KPI Goal Templates with colors and descriptions
export const departmentTemplates = [
  {
    id: "engineering_template",
    name: "Engineering",
    description: "Web / Backend / DevOps",
    color: "#1870d5",
    icon: "⚙️",
    goals: [
      {
        title: "Improve Code Quality",
        description: "Increase automated test coverage to 90%, resolve 90% of critical code quality issues, ensure code reviews for all production changes",
        weightage: 25
      },
      {
        title: "Improve System Performance",
        description: "Reduce page load time to under 2 seconds, reduce API response time to under 300 ms, decrease performance-related incidents by 30%",
        weightage: 25
      },
      {
        title: "Increase Deployment Reliability",
        description: "Achieve 98% successful deployments, reduce rollbacks to fewer than 2 per quarter, automate all production deployments",
        weightage: 25
      },
      {
        title: "Improve Platform Security",
        description: "Resolve critical vulnerabilities within 7 days, conduct regular security reviews, reduce security incidents to zero",
        weightage: 25
      }
    ]
  },
  {
    id: "product_team_template",
    name: "Product",
    description: "Product Team",
    color: "#1870d5",
    icon: "🎯",
    goals: [
      {
        title: "Deliver Roadmap on Time",
        description: "Deliver 90% of roadmap items as planned, reduce delays caused by unclear requirements, review roadmap progress monthly",
        weightage: 25
      },
      {
        title: "Improve Feature Adoption",
        description: "Achieve 60% adoption within 90 days of launch, reduce unused feature releases, track feature usage metrics consistently",
        weightage: 25
      },
      {
        title: "Improve Customer Satisfaction",
        description: "Increase product CSAT score by 10%, reduce product-related support tickets, validate solutions through user testing",
        weightage: 25
      },
      {
        title: "Improve Time to Market",
        description: "Reduce time from idea approval to release by 20%, identify and remove delivery bottlenecks, improve coordination with engineering",
        weightage: 25
      }
    ]
  },
  {
    id: "sales_template",
    name: "Sales",
    description: "Sales Team",
    color: "#1870d5",
    icon: "📈",
    goals: [
      {
        title: "Increase Revenue Performance",
        description: "Achieve quarterly revenue targets, increase average deal size, maintain healthy pipeline coverage",
        weightage: 25
      },
      {
        title: "Improve Lead Conversion",
        description: "Increase lead-to-opportunity conversion rate, reduce lead response time, improve qualification accuracy",
        weightage: 25
      },
      {
        title: "Improve Win Rate",
        description: "Increase opportunity win rate, reduce losses due to poor qualification, track and review win-loss insights",
        weightage: 25
      },
      {
        title: "Reduce Sales Cycle Length",
        description: "Reduce average sales cycle duration, decrease stalled deals in pipeline, improve follow-up consistency",
        weightage: 25
      }
    ]
  },
  {
    id: "marketing_template",
    name: "Marketing",
    description: "Marketing Team",
    color: "#1870d5",
    icon: "📢",
    goals: [
      {
        title: "Increase Qualified Leads",
        description: "Increase marketing-qualified leads by 30%, improve lead-to-opportunity conversion, reduce cost per lead",
        weightage: 25
      },
      {
        title: "Improve Campaign Effectiveness",
        description: "Achieve ROI targets for most campaigns, reduce campaign setup time, optimize campaigns based on performance",
        weightage: 25
      },
      {
        title: "Improve Content Performance",
        description: "Increase content engagement by 25%, improve average time on page, increase content-driven leads",
        weightage: 25
      },
      {
        title: "Improve SEO Performance",
        description: "Increase top-10 keyword rankings, grow organic traffic quarter over quarter, resolve technical SEO issues",
        weightage: 25
      }
    ]
  },
  {
    id: "hr_template",
    name: "HR",
    description: "Human Resources",
    color: "#1870d5",
    icon: "👥",
    goals: [
      {
        title: "Improve Employee Onboarding",
        description: "Complete onboarding within 14 days, achieve 90% new hire satisfaction, ensure onboarding checklist completion",
        weightage: 25
      },
      {
        title: "Improve Performance Reviews",
        description: "Complete 100% of reviews on time, eliminate review cycle delays, ensure actionable feedback in all reviews",
        weightage: 25
      },
      {
        title: "Improve Employee Engagement",
        description: "Increase engagement survey score by 10%, achieve at least 80% participation, act on top engagement gaps",
        weightage: 25
      },
      {
        title: "Improve Talent Retention",
        description: "Reduce voluntary attrition by 15%, conduct stay interviews for key employees, address top attrition drivers",
        weightage: 25
      }
    ]
  },
  {
    id: "customer_support_template",
    name: "Customer Support",
    description: "Support / Success Team",
    color: "#1870d5",
    icon: "💬",
    goals: [
      {
        title: "Improve Customer Satisfaction",
        description: "Increase CSAT score, reduce negative feedback trends, follow up on low CSAT responses",
        weightage: 25
      },
      {
        title: "Reduce Resolution Time",
        description: "Reduce average resolution time, resolve most tickets within SLA, improve first-contact resolution",
        weightage: 25
      },
      {
        title: "Improve Support Quality",
        description: "Reduce repeat tickets, standardize support responses, improve internal QA scores",
        weightage: 25
      },
      {
        title: "Improve Self-Service Adoption",
        description: "Increase knowledge base usage, update outdated help articles, improve self-service satisfaction",
        weightage: 25
      }
    ]
  },
  {
    id: "retail_ecommerce_template",
    name: "Retail",
    description: "E-commerce Team",
    color: "#1870d5",
    icon: "🛒",
    goals: [
      {
        title: "Increase Sales Growth",
        description: "Increase total revenue by 20%, improve website conversion rate by 15%, increase repeat purchase rate",
        weightage: 25
      },
      {
        title: "Improve Customer Experience",
        description: "Increase customer satisfaction score, reduce cart abandonment rate, improve order tracking and communication",
        weightage: 25
      },
      {
        title: "Improve Inventory Efficiency",
        description: "Reduce stockouts by 25%, improve inventory turnover rate, reduce excess or slow-moving stock",
        weightage: 25
      },
      {
        title: "Improve Fulfillment Performance",
        description: "Reduce average delivery time, increase on-time order fulfillment rate, reduce return and refund processing delays",
        weightage: 25
      }
    ]
  },
  {
    id: "manufacturing_template",
    name: "Manufacturing",
    description: "Operations Team",
    color: "#1870d5",
    icon: "🏭",
    goals: [
      {
        title: "Improve Production Efficiency",
        description: "Increase overall equipment effectiveness by 15%, reduce production downtime, improve output per shift",
        weightage: 25
      },
      {
        title: "Improve Product Quality",
        description: "Reduce defect rate by 30%, improve first-pass yield, resolve recurring quality issues faster",
        weightage: 25
      },
      {
        title: "Improve Workplace Safety",
        description: "Reduce safety incidents by 40%, complete safety audits on schedule, improve employee compliance with safety protocols",
        weightage: 25
      },
      {
        title: "Reduce Operational Costs",
        description: "Reduce material waste by 20%, improve energy efficiency across plants, lower maintenance costs through preventive planning",
        weightage: 25
      }
    ]
  },
  {
    id: "healthcare_template",
    name: "Healthcare",
    description: "Medical Team",
    color: "#1870d5",
    icon: "🏥",
    goals: [
      {
        title: "Improve Patient Satisfaction",
        description: "Increase patient satisfaction score by 10%, reduce patient wait times, improve follow-up communication after visits",
        weightage: 25
      },
      {
        title: "Improve Clinical Quality",
        description: "Reduce treatment errors, improve adherence to care protocols, increase timely completion of patient records",
        weightage: 25
      },
      {
        title: "Improve Operational Efficiency",
        description: "Reduce appointment no-show rates, improve bed or room utilization, reduce administrative delays in patient processing",
        weightage: 25
      },
      {
        title: "Strengthen Compliance and Safety",
        description: "Resolve compliance issues quickly, complete regular internal audits, reduce safety incidents affecting patients or staff to zero",
        weightage: 25
      }
    ]
  },
  {
    id: "education_training_template",
    name: "Education",
    description: "Training Team",
    color: "#1870d5",
    icon: "📚",
    goals: [
      {
        title: "Improve Learner Completion Rates",
        description: "Increase course completion rates by 20%, reduce learner drop-off during key modules, improve assignment submission rates",
        weightage: 25
      },
      {
        title: "Improve Learning Outcomes",
        description: "Increase average assessment scores, improve certification pass rates, track learning progress consistently across cohorts",
        weightage: 25
      },
      {
        title: "Improve Student Satisfaction",
        description: "Increase learner satisfaction score by 10%, reduce complaints related to course quality, act on learner feedback within each review cycle",
        weightage: 25
      },
      {
        title: "Improve Program Delivery Efficiency",
        description: "Reduce course creation time by 25%, improve trainer or instructor coordination, standardize learning materials and delivery processes",
        weightage: 25
      }
    ]
  },
  {
    id: "financial_services_insurance_template",
    name: "Financial Services",
    description: "Insurance Team",
    color: "#1870d5",
    icon: "💰",
    goals: [
      {
        title: "Improve Customer Trust and Retention",
        description: "Increase customer retention rate, reduce customer complaints, improve turnaround time for service requests",
        weightage: 25
      },
      {
        title: "Improve Operational Accuracy",
        description: "Reduce processing errors by 30%, improve first-time accuracy in applications or claims, reduce rework caused by incomplete documentation",
        weightage: 25
      },
      {
        title: "Strengthen Compliance",
        description: "Resolve compliance issues within target timelines, complete regular policy and process reviews, achieve 100% completion of mandatory compliance training",
        weightage: 25
      },
      {
        title: "Improve Service Speed",
        description: "Reduce loan, claim, or account processing time, improve response time for customer inquiries, reduce backlog in pending cases",
        weightage: 25
      }
    ]
  },
  {
    id: "logistics_supply_chain_template",
    name: "Logistics",
    description: "Supply Chain Team",
    color: "#1870d5",
    icon: "🚚",
    goals: [
      {
        title: "Improve Delivery Performance",
        description: "Increase on-time delivery rate to 95% or higher, reduce delayed shipments, improve visibility across shipment stages",
        weightage: 25
      },
      {
        title: "Improve Warehouse Efficiency",
        description: "Reduce order picking time, improve inventory accuracy to 98% or higher, reduce fulfillment errors",
        weightage: 25
      },
      {
        title: "Reduce Transportation Costs",
        description: "Lower cost per shipment, improve route efficiency, reduce fuel or carrier-related waste",
        weightage: 25
      },
      {
        title: "Improve Supply Reliability",
        description: "Reduce supplier delays, improve forecast accuracy, reduce disruptions caused by stock shortages",
        weightage: 25
      }
    ]
  },
  {
    id: "hospitality_template",
    name: "Hospitality",
    description: "Guest Services Team",
    color: "#1870d5",
    icon: "🏨",
    goals: [
      {
        title: "Improve Guest Satisfaction",
        description: "Increase guest satisfaction scores, reduce negative reviews, improve service recovery for guest complaints",
        weightage: 25
      },
      {
        title: "Increase Occupancy and Revenue",
        description: "Increase occupancy rate, improve average revenue per room or guest, increase repeat bookings",
        weightage: 25
      },
      {
        title: "Improve Service Efficiency",
        description: "Reduce guest check-in and check-out time, improve housekeeping turnaround time, reduce service delays across key touchpoints",
        weightage: 25
      },
      {
        title: "Improve Staff Productivity",
        description: "Reduce scheduling gaps, improve training completion rates, increase consistency in service standards",
        weightage: 25
      }
    ]
  },
  {
    id: "real_estate_property_management_template",
    name: "Real Estate",
    description: "Property Management",
    color: "#1870d5",
    icon: "🏠",
    goals: [
      {
        title: "Increase Occupancy Rate",
        description: "Increase occupancy across managed properties, reduce vacancy period between tenants, improve lead-to-lease conversion rate",
        weightage: 25
      },
      {
        title: "Improve Tenant Satisfaction",
        description: "Increase tenant satisfaction score, reduce unresolved maintenance complaints, improve communication response times",
        weightage: 25
      },
      {
        title: "Improve Maintenance Efficiency",
        description: "Reduce average maintenance resolution time, complete preventive maintenance on schedule, reduce repeat maintenance issues",
        weightage: 25
      },
      {
        title: "Improve Revenue Performance",
        description: "Increase rental collection rate, reduce overdue payments, improve renewal rate for existing tenants",
        weightage: 25
      }
    ]
  },
  {
    id: "construction_template",
    name: "Construction",
    description: "Project Management",
    color: "#1870d5",
    icon: "🏗️",
    goals: [
      {
        title: "Improve Project Delivery",
        description: "Complete 90% of projects on schedule, reduce delays caused by planning gaps, review project milestones weekly",
        weightage: 25
      },
      {
        title: "Improve Cost Control",
        description: "Reduce budget overruns, improve material usage efficiency, track and address cost variance early",
        weightage: 25
      },
      {
        title: "Improve Site Safety",
        description: "Reduce safety incidents by 40%, complete all site safety inspections on time, improve compliance with safety procedures",
        weightage: 25
      },
      {
        title: "Improve Quality of Execution",
        description: "Reduce rework by 25%, improve first-time inspection pass rates, resolve quality issues before final handover",
        weightage: 25
      }
    ]
  },
  {
    id: "food_beverage_restaurant_template",
    name: "Food & Beverage",
    description: "Restaurant Team",
    color: "#1870d5",
    icon: "🍽️",
    goals: [
      {
        title: "Improve Customer Experience",
        description: "Increase customer satisfaction scores, reduce complaints about food or service, improve repeat visit rate",
        weightage: 25
      },
      {
        title: "Improve Operational Efficiency",
        description: "Reduce average order preparation time, improve table turnover without affecting service quality, reduce delays in peak-hour service",
        weightage: 25
      },
      {
        title: "Improve Cost Management",
        description: "Reduce food waste by 20%, improve inventory control accuracy, lower cost variance across outlets",
        weightage: 25
      },
      {
        title: "Improve Staff Performance",
        description: "Improve training completion rate, reduce scheduling and attendance issues, increase consistency in service quality",
        weightage: 25
      }
    ]
  }
];
